import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorSubmitService {

  public errorEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  emitError(data: any){
    this.errorEvent.emit(data);
  }
}
